export default "__VITE_ASSET__fbc1b44c__"